import Vue from 'vue'
import Vuex from 'vuex'
import routes, {asyncRouterMap} from "../routes";


Vue.use(Vuex)

// 应用初始状态
const state = {
    roles: "",
    routers:routes,
    addRouters: []
}
const getters = {   //实时监听state值的变化(最新状态)
        getRoutes:(state)=>{
            return state.routers;
        },
        getRole:(state)=>{
            return state.routers;
        },
    addRouters:(state)=>{
            return state.addRouters;
    }
};
// 定义所需的 mutations
const mutations = {
    set_roles:(state,roles)=>{
        state.roles=roles;
    },
    SET_ROUTERS: (state, route) => {
        state.addRouters = route;
        console.log("routes==",routes);
        state.routers = routes.concat(route);
    }
}
const actions = {
    SetRole({commit},data){
        commit('set_roles', data);
    },
    GenerateRoutes({commit},data) {
        return new Promise(resolve => {;

            const roles=data && data.length>0?data.split(";"):"";
            console.log("roles",roles)
            const accessedRouters = asyncRouterMap.filter(v => {
             //   if (roles.indexOf('SUPER_ADMIN') >= 0) return true;
                if (hasPermission(roles, v)) {
                    if (v.children && v.children.length > 0) {
                        v.children = v.children.filter(child => {
                            if (hasPermission(roles, child)) {

                                if (child.children && child.children.length > 0) {
                                    child.children = child.children.filter(childSun => {
                                        if (hasPermission(roles, childSun)) {
                                            return childSun;
                                        }
                                        return false;
                                    });
                                    return child
                                } else {
                                    return child
                                }

                            }
                            return false;
                        });
                        return v
                    } else {
                        return v
                    }
                }
                return false;
            });
            console.log("accessedRouters====",accessedRouters);
            commit('SET_ROUTERS', accessedRouters);
            commit('set_roles', roles);
            resolve();
        })
    }
};

function hasPermission(roles, route) {
    if (route.meta && route.meta.roles) {
        for(var i=0;i<roles.length;i++){
            console.log('route==',route.meta.roles.indexOf(roles[i]));
            console.log('route==',route);
            if(route.meta.roles.indexOf(roles[i])!=-1){
                return true;
            }
        }
    } else {
        return true
    }
}
// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js